import { render, staticRenderFns } from "./news2.vue?vue&type=template&id=33d77181&scoped=true"
import script from "./news2.vue?vue&type=script&lang=js"
export * from "./news2.vue?vue&type=script&lang=js"
import style0 from "./news2.vue?vue&type=style&index=0&id=33d77181&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d77181",
  null
  
)

export default component.exports